'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var ObjectHelper = require('../../common/ObjectHelper.js');

var MILES_TO_METERS = 1609;
var MILES_TO_LATITUDE = 1 / 111111;
var MILES_TO_LONGITUDE = 1.2 / 111111;
var ENDPOINTS_IN_A_LINE = 2;
var polygon;
var mapsContainingPolygon;

var initialPolygonCoordinates = function initialPolygonCoordinates(lat, lng, radius) {
  var radiusToLat = radius * MILES_TO_LATITUDE;
  var radiusToLng = radius * MILES_TO_LONGITUDE;
  var coordinates = [];

  for (var angle = 0.0; angle <= 2 * Math.PI; angle += Math.PI / 8) {
    coordinates.push({
      lat: lat + radiusToLat * Math.sin(angle),
      lng: lng + radiusToLng * Math.cos(angle)
    });
  }

  return coordinates;
};

var setPolygonCoordinates = function setPolygonCoordinates(coordinates, onPolygonEdit) {
  if (ObjectHelper.isBlank(polygon)) {
    throw new Error('Polygon is not initialized! Initialize by calling buildPolygon().');
  }

  polygon.setPath(coordinates);
  mapsContainingPolygon.event.addListener(polygon.getPath(), 'insert_at', function () {
    return onPolygonEdit();
  });
  mapsContainingPolygon.event.addListener(polygon.getPath(), 'set_at', function () {
    return onPolygonEdit();
  });
};

var buildPolygon = function buildPolygon(map, maps, lat, lng, polygonCoordinates, radius, isBeingEdited, onPolygonEdit, fitPolygonInMap) {
  var coordinates = ObjectHelper.isBlank(polygonCoordinates) || polygonCoordinates.length <= ENDPOINTS_IN_A_LINE ? initialPolygonCoordinates(lat, lng, radius * MILES_TO_METERS) : polygonCoordinates.map(function (coordinate) {
    return {
      lat: Number(coordinate.lat),
      lng: Number(coordinate.lng)
    };
  });
  polygon = new maps.Polygon({
    paths: coordinates,
    strokeColor: 'red',
    strokeOpacity: 0.7,
    strokeWeight: 1,
    fillColor: '#FF0000',
    fillOpacity: 0.2,
    map: map,
    editable: isBeingEdited
  });
  maps.event.addListener(polygon.getPath(), 'insert_at', function () {
    return onPolygonEdit();
  });
  maps.event.addListener(polygon.getPath(), 'set_at', function () {
    return onPolygonEdit();
  });
  mapsContainingPolygon = maps;
  polygon.setMap(map);

  if (fitPolygonInMap) {
    var mapBounds = new maps.LatLngBounds();
    getPolygonCoordinates().map(function (coordinate) {
      mapBounds.extend({
        lat: Number(coordinate.lat),
        lng: Number(coordinate.lng)
      });
    });
    map.fitBounds(mapBounds);
  }
};
var getPolygonCoordinates = function getPolygonCoordinates() {
  if (ObjectHelper.isBlank(polygon)) {
    throw new Error('Polygon is not initialized! Initialize by calling buildPolygon().');
  }

  var coordinates = [];
  polygon.getPath().forEach(function (coordinate) {
    coordinates.push({
      lat: "".concat(coordinate.lat()),
      lng: "".concat(coordinate.lng())
    });
  });
  return coordinates;
};
var updatePolygon = function updatePolygon(polygonCoordinates, onPolygonEdit) {
  if (ObjectHelper.isBlank(polygon)) return;
  var coordinates = polygonCoordinates.map(function (coordinate) {
    return {
      lat: Number(coordinate.lat),
      lng: Number(coordinate.lng)
    };
  });
  setPolygonCoordinates(coordinates, onPolygonEdit);
};
var resetPolygon = function resetPolygon(lat, lng, radius, onPolygonEdit) {
  var coordinates = initialPolygonCoordinates(lat, lng, radius * MILES_TO_METERS);
  setPolygonCoordinates(coordinates, onPolygonEdit);
};

exports.buildPolygon = buildPolygon;
exports.getPolygonCoordinates = getPolygonCoordinates;
exports.resetPolygon = resetPolygon;
exports.updatePolygon = updatePolygon;
